import { z } from 'zod';
import { EstadoSchema, IsoDateTimeSchema, ModuleCodeSchema, PaginationSchema, RoleSchema, UuidSchema, } from './common.js';
// Criação de usuário via convite: sem senha no payload — o admin gera depois um
// link de definição de senha (/auth/password-reset → /auth/set-password).
export const CreateAdminUserRequestSchema = z.object({
    email: z.string().email(),
    nombreCompleto: z.string().min(1).max(200),
    rol: RoleSchema,
    estado: EstadoSchema.default('activo'),
    sucursalId: UuidSchema.nullable().optional(),
});
// Whitelist explícita anti mass-assignment (P-016): email/passwordHash NÃO editáveis aqui.
export const UpdateAdminUserRequestSchema = z.object({
    nombreCompleto: z.string().max(200).nullable().optional(),
    rol: RoleSchema.nullable().optional(),
    estado: EstadoSchema.nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
    startupModule: ModuleCodeSchema.nullable().optional(),
});
export const AdminUserListQuerySchema = PaginationSchema.extend({
    rol: RoleSchema.optional(),
    estado: EstadoSchema.optional(),
});
export const SetUserModuleRequestSchema = z.object({
    enabled: z.boolean(),
});
// Asignación de cajas a usuarios (cajas_usuarios / CajaUsuario).
export const CajaUsuarioSchema = z.object({
    id: UuidSchema,
    usuarioId: UuidSchema,
    cajaId: UuidSchema,
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateCajaUsuarioRequestSchema = z.object({
    usuarioId: UuidSchema,
    cajaId: UuidSchema,
});
export const CajaUsuarioListQuerySchema = z.object({
    usuarioId: UuidSchema.optional(),
    cajaId: UuidSchema.optional(),
});
// Asignación de sucursales a usuarios (sucursales_usuarios / SucursalUsuario).
// Fonte primária do scope de caja (ADR-024).
export const SucursalUsuarioSchema = z.object({
    id: UuidSchema,
    usuarioId: UuidSchema,
    sucursalId: UuidSchema,
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateSucursalUsuarioRequestSchema = z.object({
    usuarioId: UuidSchema,
    sucursalId: UuidSchema,
});
export const SucursalUsuarioListQuerySchema = z.object({
    usuarioId: UuidSchema.optional(),
    sucursalId: UuidSchema.optional(),
});
//# sourceMappingURL=admin.js.map